import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IProductsService } from 'libs/core/src/lib/services/products.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import {
  createQueryParams,
  IMotorProduct,
  IProductQueryParams,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PartnerProductsService implements IProductsService {
  private rep = inject(RepresentativeService);

  constructor(private http: HttpClient) {}

  getAllMotorProducts(
    query?: IProductQueryParams,
  ): Observable<IMotorProduct[]> {
    const PartnerId = this.rep.getLoggedInPartnerRepresentative().partnerId;
    return this.http.get<IMotorProduct[]>(`${baseUrl()}/products/motor`, {
      params: createQueryParams({
        ...query,
        PartnerId,
      }),
    });
  }
  deleteProduct(id: number): Observable<unknown> {
    return this.http.delete(`${baseUrl()}/products/${id}`);
  }
}
